import React, { useContext, useState, useEffect } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../Services/BackEndAPI'
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { EMDESENVOLVIMENTO, VERSAO_SISTEMA } from '../../ImportBackend/Config/emDesenvolvimento'
import ClsUtils from 'zlib-utils'
import Condicional from '../../Layout/Condicional'
import { useNavigate } from 'react-router-dom'
import { UsuarioLogadoInterface, VersaoTypeInterface } from '../../ImportBackend/Interfaces/LoginInterfaces'
import { PermissoesInterface } from '../../ImportBackend/Interfaces/SistemaModuloPermissaoInterfaces'
import ClsMenu from '../../Layout/MenuCls'
import { PAGINAINICIALEMDESENVOLVIMENTO } from '../../Config/ConfigFrontEnd'
import MsgErroAplicacao from '../../DevComponents/MsgErroAplicacao'

interface LoginInterface {
  login: string
  senha: string
}

export default function Login() {

  const dados = EMDESENVOLVIMENTO ? {
    "login": "Zanatta",
    "senha": "Teste123"
  } : { senha: '', login: '' }

  const contextoGlobal = useContext(ContextoGlobal) as ContextoGlobalInterface

  const { layoutState, setLayoutState } = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = (useContext(ContextoGlobal) as ContextoGlobalInterface)
  const { loginState, setLoginState } = (useContext(ContextoGlobal) as ContextoGlobalInterface)

  const [usuarioState, setUsuarioState] = useState<LoginInterface>(dados)

  const [exibirSenhaState, setExibirSenha] = useState(false)

  const [versaoOK, setVersaoOK] = useState(true)

  const navigate = useNavigate()

  const clsApi = new BackEndAPI()

  const irPaginaInicial = () => {

    if (EMDESENVOLVIMENTO && PAGINAINICIALEMDESENVOLVIMENTO.length > 0) {

      navigate(PAGINAINICIALEMDESENVOLVIMENTO)

    } else {

      navigate('/SetCliente')

      /*
      if ( idClienteAtual === 0 ) {
        navigate( '/SetCliente' )

      } else {
        navigate( '/' )
      }
        */

    }
  }

  const abortController: AbortController = new AbortController()

  useEffect(() => {

    const query: string = `
      versao {
        versao
        desenvolvimento
      }
    `

    clsApi.query<VersaoTypeInterface>(query, 'versao', 'Verificando Versao...', contextoGlobal, abortController).then(rs => {

      setMensagemState({ ...mensagemState, exibir: false })

      if (rs.desenvolvimento === EMDESENVOLVIMENTO && rs.versao === VERSAO_SISTEMA) {
        setVersaoOK(true)
        logarPorToken()
      } else {
        // navigate( '/ErroVersao' )
        setVersaoOK(false)
      }

    }).catch(() => {

      navigate('/ErroAplicacao')

    })

    return () => {

      abortController.abort()

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleExibirSenha = () => {
    setExibirSenha(!exibirSenhaState)
  }

  const setarPermissoesEMenu = (token: string, idClienteAtual: number, idUsuario: number, nome: string, obrigatorioAlterarSenha: boolean) => {

    const query: string = `
      getPermissoes {
        modulo
        permissao
      }
    `

    clsApi.query<Array<PermissoesInterface>>(query, 'getPermissoes', 'Recebendo Permissões...', contextoGlobal).then(rsPermissoes => {

      const clsMenu = (new ClsMenu(rsPermissoes))

      setLayoutState({ ...layoutState, opcoesMenu: clsMenu.MenuOpcoes })
      setLoginState({ ...loginState, permissoes: rsPermissoes, idUsuario: idUsuario, logado: true, token: token, idClienteAtual: idClienteAtual, nome: nome, obrigatorioAlterarSenha: obrigatorioAlterarSenha })

      irPaginaInicial()

    }).catch(err => {
      setMensagemState({
        ...mensagemState,
        exibir: true,
        mensagem: 'Erro ao Receber Permissões. Consulte Suporte.',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })
    })

  }

  const logarPorToken = () => {

    const token = localStorage.getItem('token');

    if (token && token.length > 0) {

      const mutation: string = `
        logarPorToken {
          idUsuario
          mensagem
          ok
          token
          idClienteAtual
          nome
          alterarSenhaNoProximoAcesso
          urlInicial
        }
      `

      clsApi.mutation<UsuarioLogadoInterface>(mutation, 'logarPorToken', 'Login Automático...', contextoGlobal).then(rs => {

        if (rs.ok && rs.token && rs.token.length > 0 && rs.nome && rs.nome.length > 0) {

          // TODO - Trocar para Token em Memória....
          localStorage.setItem('token', rs.token)

          setarPermissoesEMenu(rs.token, rs.idClienteAtual, rs.idUsuario, rs.nome, rs.alterarSenhaNoProximoAcesso)

        }

      }).catch(() => {

        setMensagemState({
          ...mensagemState,
          exibir: true,
          mensagem: 'Login Não Realizado!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      })

    }

  }

  const logar = () => {

    const mutation: string = `
      logar(login: ${(new ClsUtils()).ConverterEmGql(usuarioState)} ) {
        idUsuario
        mensagem
        ok
        alterarSenhaNoProximoAcesso
        urlInicial
        token
        idClienteAtual
        nome
      }
    `

    clsApi.mutation<UsuarioLogadoInterface>(mutation, 'logar', 'Logando', contextoGlobal).then(rs => {

      if (rs.ok && rs.token && rs.token.length > 0 && rs.nome && rs.nome.length > 0) {

        // TODO - Trocar para Token em Memória....
        localStorage.setItem('token', rs.token)

        setarPermissoesEMenu(rs.token, rs.idClienteAtual, rs.idUsuario, rs.nome, rs.alterarSenhaNoProximoAcesso)

      } else {
        setMensagemState({
          ...mensagemState,
          exibir: true,
          mensagem: 'Verifique Usuário / Senha!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })
      }

    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        exibir: true,
        mensagem: 'Login Não Realizado!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })


  }

  return (
    <>
      <Box style={{
        backgroundImage: `url("${process.env.REACT_APP_PASTA}/fundoazul.png")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}>

        <Box
          sx={{
            position: "absolute",
            inset: 0, // top:0 right:0 bottom:0 left:0
            display: { xs: 'none', sm: "grid" },
            gridTemplateColumns: "repeat(4, 1fr)",
          }}
        >
          <Box
            sx={{
              gridColumn: "1 / 4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Box>
                <Typography component="p" variant="h4" color="white" sx={{ mr: 10 }}>
                  Bem Vindo!
                </Typography>
              </Box>
              <Box>
                <img src={process.env.REACT_APP_PASTA?.concat("/logobranca.png")} width={100} alt={process.env.REACT_APP_TITULO} />
              </Box>
            </Box>

          </Box>

        </Box>

      </Box>

      <Condicional condicao={!versaoOK}>
        <MsgErroAplicacao titulo='Versão Desatualizada!' mensagem='Atualize a tela com CTRL + F5 ou botão reload no seu celular!'>
          <Button variant='contained' onClick={() => window.location.reload()} sx={{ width: '100%', backgroundColor: '#ff6333' }}>Atualizar!</Button>
        </MsgErroAplicacao>
      </Condicional>

      <Condicional condicao={versaoOK}>
        <Grid
          container
          justifyContent='right'
          sx={{ minHeight: '100vh', position: 'absolute', top: 0, left: 0 }}
        >
          <Grid item xs={11} md={4} lg={3}>

            <Paper
              sx={{
                position: 'relative',
                minHeight: '100vh',
                right: 0,
                bottom: 0,
                backgroundColor: '#EEEDFF',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '100px',
                  backgroundImage: `url(${process.env.REACT_APP_PASTA?.concat("/logorodapevertical.png")})`,
                  backgroundRepeat: 'repeat-x',
                  backgroundSize: '50px',
                  backgroundColor: '#EEEDFF'
                }
              }}
            >
              <Box
                sx={{ backgroundColor: '#EEEDFF', padding: 2 }}
                textAlign='center'
              >
                <img src={process.env.REACT_APP_PASTA?.concat("/logomarca.png")} width={300} alt={process.env.REACT_APP_TITULO} style={{ display: 'block', margin: 'auto', marginTop: '30px' }} />
                <Typography component="p" variant="h6" color="black" sx={{ mt: 2 }}>
                  Iniciar Sessão
                </Typography>
              </Box>
              <Box
                sx={{ padding: 0, mx: 5 }}
              >
                <Grid>

                  <Grid item>
                    <InputText
                      dados={usuarioState}
                      field='login'
                      label='Usuário'
                      setState={setUsuarioState}
                    />
                  </Grid>

                  <Grid item>
                    <InputText
                      dados={usuarioState}
                      field='senha'
                      label='Senha'
                      type={exibirSenhaState ? "text" : "password"}
                      setState={setUsuarioState}
                      iconeEnd='visibility'
                      onClickIconeEnd={handleExibirSenha}
                    />
                  </Grid>

                  <Grid item sx={{ mt: 2 }}>
                    <Stack direction='row' spacing={5} justifyContent='space-between' alignItems='center'>
                      <Typography variant="body2" color="primary.main" sx={{ cursor: 'pointer' }} onClick={() => setLoginState({ ...loginState, esqueceuSenha: true, logado: false, obrigatorioAlterarSenha: false })}>Esqueci minha senha</Typography>
                      <Button variant='contained' onClick={() => logar()}>Login</Button>
                    </Stack>
                  </Grid>

                </Grid>

              </Box>
            </Paper>


          </Grid>
        </Grid>
      </Condicional>
    </>
  )

}